import React from 'react';
import ListCosting from './listCosting';

// La liste porte ses propres fiches : cet enrobage n'ajoutait qu'une grille.
function Costings() {
  return <ListCosting />;
}

export default Costings;
